const routePaths = {
  HOME: '/',
  ABOUT_PROJECT: '/about-project',
  ABOUT: '/about',
  GALLERY: '/gallery',
  STATISTICS: '/statistics',
  EXPLANATION: '/how_it_works',
  LEGALNOTICE: '/legalnotice',
  TAGS: '/tags',
  KEYWORDS: '/keywords',
  LOCATION: '/location',
  GENERATE: '/generate',
  CARD: '/:id',
  CARD_OLD: '/card/:id',
}

export default routePaths
